import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import SidebarQuery, {
	type JsmProjectMenuWrapper_SidebarQuery,
} from '@atlassian/jira-relay/src/__generated__/JsmProjectMenuWrapper_SidebarQuery.graphql';
import { withGiraAggAnonSsrFix } from '@atlassian/jira-navigation-apps-resources/src/common/utils.tsx';

export const getQuery: Parameters<
	typeof createRelayResource<JsmProjectMenuWrapper_SidebarQuery>
>[0]['getQuery'] = ({ match, query }, { tenantContext: { cloudId } }) => {
	let { projectKey } = getProjectKeyId(match, query);
	projectKey = projectKey ?? '';

	return {
		options: {
			fetchPolicy: 'store-and-network' as const,
		},
		parameters: SidebarQuery,
		variables: {
			cloudId,
			projectKey,
		},
	};
};

export const jsmProjectMenuContentSidebarResource = withGiraAggAnonSsrFix(
	createRelayResource<JsmProjectMenuWrapper_SidebarQuery>({
		type: 'JSM_PROJECT_MENU_CONTENT_SIDEBAR_QUERY',
		getQuery,
	}),
);
